// using global state management with React Context API to store the user's authentication status and details.
// thus any component can access the user's authentication status and details without prop drilling.
import React, { createContext, useContext, useState} from "react";

const UserContext = createContext();

export const useUser = () => useContext(UserContext);
export const UserProvider = ({children}) => {
    const [user, setUser] = useState(null);

    return (
        <UserContext.Provider value={{user, setUser}}>
            {children}
        </UserContext.Provider>
    )
};
